import { Button, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router";

import fontWeight from "../../../styles/mui/fontWeight";
import { colors } from "../../../styles/colors";
import { confirmationDialogBox, FaCheckCircleIcon } from "../styles/style";
import { ApplicationRoute } from "../../../constants/ApplicationUrl";
import { ConfirmationMessageType } from "../../../constants/Referral";

export interface Props {
    confirmationMessageTitle: ConfirmationMessageType;
    setOpenConfirmation: (value: boolean) => void;
    openConfirmation: boolean;
}
const ConfirmationDialog = ({
    openConfirmation,
    setOpenConfirmation,
    confirmationMessageTitle,
}: Props) => {

  const navigate = useNavigate();

  const handleClose = () => {
    setOpenConfirmation(false);
    navigate(ApplicationRoute.HOME);
  };

  return (
    <Dialog
      open={openConfirmation}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableScrollLock
      sx={confirmationDialogBox}
      maxWidth={'xs'}
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">
        <FaCheckCircleIcon />
        <Typography
          variant="body1"
          fontSize=".85rem"
          margin={"0.5rem 0 0.5rem"}
          padding={"1.4rem 5rem"}
          fontWeight={fontWeight[6]}
          color={colors.black[11]}
        >
          {confirmationMessageTitle.title}
        </Typography>
      </DialogTitle>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button variant="contained" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
